import React from "react";

import {
    BrandListItem,
    BrandListItemPlaceholder,
} from "@/mk2/apps/strollers/components/BrandListItem";
import { Props } from "@/mk2/apps/strollers/containers/Brands/BrandsPage";
import { InfiniteListLoadable } from "@/mk2/components/InfiniteListLoadable";
import { NoResults } from "@/mk2/components/NoResults";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { LoadingState } from "@/mk2/reducers/loadingState";
import { STROLLER_NO_RESULTS } from "@/mk/autogenerated/translations/Brands.94d38a7c3f7c1222d98c51b90f80a222";

import styles from "./Brands.mscss";

const ROW_HEIGHT = 56;

export class Brands extends React.Component<Props> {
    public render() {
        const { brands, loadingState } = this.props;

        return (
            <div className={styles.Brands}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={brands?.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        return (
            <span>
                <BrandListItemPlaceholder />
                <BrandListItemPlaceholder />
                <BrandListItemPlaceholder />
                <BrandListItemPlaceholder />
                <BrandListItemPlaceholder />
                <BrandListItemPlaceholder isLast />
            </span>
        );
    };

    private renderLoadSuccess = () => {
        const { brands, hasMore } = this.props;
        const rowCount = hasMore ? brands.length + 1 : brands.length;

        return brands.length > 0 ? (
            <InfiniteListLoadable
                isRowLoaded={this.isRowLoaded}
                loadMoreRows={this.loadNext}
                rowCount={rowCount}
                rowHeight={ROW_HEIGHT}
                rowRenderer={(props) => this.rowRenderer(props)}
                numberOfItemsOnFirstPage={100}
            />
        ) : (
            <NoResults message={STROLLER_NO_RESULTS} noIcon />
        );
    };

    private load = () => {
        this.props.onLoad();
        this.props.onStrollersComparisonLoad();
    };

    private loadNext = () => {
        // Do not trigger next load
        if (this.props.loadingState === LoadingState.LOADING) {
            return;
        }

        const { brands, onLoad } = this.props;

        let after = null;
        if (brands.length) {
            after = brands[brands.length - 1].slug;
        }
        onLoad(after);

        // Debounce loadMoreRows
        return new Promise((resolve) => {
            setTimeout(resolve, 500);
        });
    };

    private isRowLoaded = ({ index }) => !this.props.hasMore || index < this.props.brands.length;

    private rowRenderer = ({ index, key, style }) => {
        const { brands, strollersCountPerBrand, hasMore } = this.props;

        if (!this.isRowLoaded({ index })) {
            return <BrandListItemPlaceholder key={key} style={style} />;
        }

        const item = brands[index];

        return (
            <BrandListItem
                brand={item}
                key={key}
                style={style}
                count={strollersCountPerBrand[item.id]}
                isLast={index + 1 === brands.length && !hasMore}
            />
        );
    };
}
